import { _ as r } from "./index507.mjs";
var u = r;
function i(a, s) {
  return u(a, s);
}
var l = i;
export {
  l as i
};
